



















































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import setting from '@/core/setting'
import AuthApi from '@/api/auth'
import { passwordReg } from '@/utils/regExp'
import { passwordValidate } from '@/utils/validator'

let timer: any = ''

@Component({
	name: 'forgotPwd',
})
export default class Login extends Vue {
	private verifyURL: string = ''
	private form: any = {}
	private loading: boolean = false
	private txt: any = '获取验证码'
	private disabled: boolean = false
	private requireVerifyCode: boolean = false
	private passwordReg: any = passwordReg

	private created() {
		this.form = this.$form.createForm(this)
		this.getVerifyImage()
	}

	public checkPass(rule: string, value: string, cb: any) {
		value = value || ''
		const res = passwordValidate(value)
		if (res === true) {
			cb()
		} else {
			cb(new Error(res))
		}
	}

	private resetSmsBtn() {
		this.disabled = false
		clearInterval(timer)
		this.txt = '获取验证码'
	}

	private async getForgotPwdValidateCode() {
		this.form.resetFields(['code'])
		this.form.validateFields(
			['mobile', 'imageCode'],
			async (error: any, values: any) => {
				if (!error) {
					try {
						this.disabled = true
						let sec = 60
						this.txt = `已发送(${sec}s)`
						clearInterval(timer)
						timer = setInterval(() => {
							sec--
							if (sec <= 0) {
								this.disabled = false
								clearInterval(timer)
								this.txt = '重新发送短信'
								return
							}
							this.txt = `已发送(${sec}s)`
						}, 1000)
						await AuthApi.forgotPwdValidateCode({
							mobile: values.mobile,
							imageCode: values.imageCode,
						})
					} catch ({ errors }) {
						clearInterval(timer)
						this.getVerifyImage()
						this.txt = '获取验证码'
						this.disabled = false
					}
				}
			}
		)
	}

	private getVerifyImage() {
		this.verifyURL =
			process.env.VUE_APP_API_KEY + 'injury/user/verifyCode?' + Math.random()
		this.resetSmsBtn()
	}

	private confirm(rule: string, value: string, cb: any) {
		const newPwd = this.form.getFieldValue('newPwd')
		if (!value) {
			cb(new Error('请再次输入登录密码'))
		} else if (value !== newPwd) {
			cb(new Error('两次输入密码不一致'))
		} else {
			cb()
		}
	}

	private handleLoginSubmit(e: any) {
		e.preventDefault()
		if (this.loading) {
			return
		}
		this.form.validateFields((error: any, values: any) => {
			if (!error) {
				this.loading = true
				AuthApi.setForgotPwd({
					mobile: values.mobile,
					code: values.code,
					pwd: values.newPwd,
				})
					.then((res: any) => {
						this.$router.replace('/passport/login')
						this.$message.success('修改密码成功！')
					})
					.catch(() => {
						this.form.setFieldsValue({
							newPwd: undefined,
							confirmPwd: undefined,
							imageCode: undefined,
							code: undefined,
						})
					})
					.finally(() => {
						setTimeout(() => {
							this.loading = false
						}, 500)
					})
			}
		})
	}
}
